"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupPreventAccidentalCloseListener = void 0;
const models_1 = require("@creature-chess/models");
const setupPreventAccidentalCloseListener = (startListening) => {
    startListening({
        actionCreator: models_1.ClientUi.gameStartedCommand,
        effect: (_action, api) => __awaiter(void 0, void 0, void 0, function* () {
            api.cancelActiveListeners();
            window.onbeforeunload = () => "Are you sure you want to leave this page? There is currently no way to rejoin a game";
            yield api.take((a) => a.type === models_1.PlayerActions.quitGamePlayerAction.type);
            // Let the quit packet flush before navigating away.
            setTimeout(() => {
                window.onbeforeunload = null;
                window.location.href = APP_URL;
            }, 100);
        }),
    });
};
exports.setupPreventAccidentalCloseListener = setupPreventAccidentalCloseListener;
